<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="saveButtonAction" title="Save Confirmation - Approval Instance">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-approval-tag" label-cols-sm="4" label-cols-lg="3" label="Approval Tag" label-for="filter-approval-tag">
						{{ model != null ? model.approvalTag : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-configuration" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration" label-for="filter-approval-configuration">
						{{ model != null ? ( model.approvalConfiguration != null ? model.approvalConfiguration.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-configuration-instance" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Instance" label-for="filter-approval-configuration-instance">
						{{ model != null ? ( model.approvalConfigurationInstance != null ? model.approvalConfigurationInstance.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-type" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="filter-approval-type">
						{{ model != null ? ( model.approvalType != null ? model.approvalType.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-current-approver-sequence" label-cols-sm="4" label-cols-lg="3" label="Current Approver Sequence" label-for="filter-current-approver-sequence">
						{{ model != null ? model.currentApproverSequence : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-state" label-cols-sm="4" label-cols-lg="3" label="Approval State" label-for="filter-approval-state">
						{{ model != null ? ( model.approvalState != null ? model.approvalState.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-document-id" label-cols-sm="4" label-cols-lg="3" label="Document Id" label-for="filter-document-id">
						{{ model != null ? model.documentId : "" }}
					</b-form-group>
					<b-form-group id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status">
						{{ model != null ? model.status : "" }}
					</b-form-group>
					<b-form-group id="fieldset-originator" label-cols-sm="4" label-cols-lg="3" label="Originator" label-for="filter-originator">
						{{ model != null ? ( model.originator != null ? model.originator.firstName : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-structure" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" label-for="filter-approval-structure">
						{{ model != null ? ( model.approvalStructure != null ? model.approvalStructure.name : "") : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
<!--APP_DETAIL_TABLE-->
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approvers State</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approverStatePageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approverStates" :fields="fieldsApproverState" :busy="isDataLoading" :sort-by.sync="sortByApproverState" :sort-desc.sync="sortDescApproverState" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(actions)>
				<b-button @click="isShowApproverStateFilter = !isShowApproverStateFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowApproverStateFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filterApproverState.approverTypeId" :reduce="item => item.id" v-model="filterApproverState.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filterApproverState.approvalStructureId" :reduce="item => item.id" v-model="filterApproverState.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApproverState.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApproverState.approverUserId" :reduce="item => item.id" v-model="filterApproverState.approverUserId" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Activity State">
					<v-select append-to-body label="name" :options="activityStates" :value="filterApproverState.activityStateId" :reduce="item => item.id" v-model="filterApproverState.activityStateId" @search="getActivityStates" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Configuration Detail">
					<v-select append-to-body label="approverType" :options="approvalConfigurationInstanceDetails" :value="filterApproverState.approvalConfigurationInstanceDetailId" :reduce="item => item.id" v-model="filterApproverState.approvalConfigurationInstanceDetailId" @search="getApprovalConfigurationInstanceDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Sequence">
					<b-form-input id="input-sequence-table" v-model="filterApproverState.sequence" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApproverState.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApproverState.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th></b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approverStatePageSize * (currentApproverStatePage - 1))) }}
			</template>
			<template v-slot:cell(approvalInstance)="row">
				{{ row.item.approvalInstance != null ? row.item.approvalInstance.approvalTag : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(approverUser)="row">
				{{ row.item.approverUser != null ? row.item.approverUser.firstName : "" }}
			</template>
			<template v-slot:cell(activityState)="row">
				{{ row.item.activityState != null ? row.item.activityState.name : "" }}
			</template>
			<template v-slot:cell(approvalConfigurationInstanceDetail)="row">
				{{ row.item.approvalConfigurationInstanceDetail != null ? row.item.approvalConfigurationInstanceDetail.approverType : "" }}
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="12">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentApproverStatePage"
			:total-rows="totalApproverStateRow"
			:per-page="approverStatePageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</b-card>
<!--END_APP_DETAIL_TABLE-->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceList from '@/models/ApprovalInstance/ApprovalInstanceList';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';

import ApproverState from '@/models/ApprovalInstance/ApproverState';
import ApproverStateFilter from '@/filters/ApprovalInstance/ApproverStateFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	/*APP_DETAIL_PROP_DEFINITION*/
	props : ["openPopup", "modelId", "saveActionMethod", "resetMethod"],
	/*END_APP_DETAIL_PROP_DEFINITION*/
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			model: {},
			datas: Array(),
			fieldsApproverState: [
				{"no" : {  "class" : "th-number" }},
				{"approverType": {},  "class" : "th-approver-type", "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": {},  "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": {},  "class" : "th-approver-level", "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUser": {},  "class" : "th-approver-user", "label" : "Approver User", key: 'approverUser', sortable: true}, 
				{"activityState": {},  "class" : "th-activity-state", "label" : "Activity State", key: 'activityState', sortable: true}, 
				{"approvalConfigurationInstanceDetail": {},  "class" : "th-approval-configuration-instance-detail", "label" : "Approval Configuration Detail", key: 'approvalConfigurationInstanceDetail', sortable: true}, 
				{"sequence": {},  "class" : "th-sequence", "label" : "Sequence", key: 'sequence', sortable: true}, 
				{"storedProcedureName": {},  "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"isSendNotification": {},  "class" : "th-is-send-notification", "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			/*APP_DETAIL_PAGINATION*/
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterApprovalInstance : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentApprovalInstancePage : 1,
			approvalInstancePageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByApprovalInstance: '',
			sortDescApprovalInstance: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			filterApproverState : null,
			currentApproverStatePage : 1,
			approverStatePageSize: 10,
			sortByApproverState: '',
			sortDescApproverState: '',
			sortingByApproverState: [],
			approverStates : [],
			approverStateId : '',
			totalApproverStateRow : 0,
			isShowApproverStateFilter: false,
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			activityStates: [],
			approvalConfigurationInstanceDetails: [],
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETApprovalInstance*/
		getApprovalInstance : async function(id) {
			this.isBusy = true;
			ApprovalInstance.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETApprovalInstance*/
		/*APP_DETAIL_GETApproverState*/
		getApproverStates : async function() {
			let filter = {};
			Object.assign(filter, this.filterApproverState);
			if (this.modelId == null) return;
			filter.approvalInstanceId = this.modelId;
			this.sortingByApproverState = Array();
			if (this.sortByApproverState != null) {
				this.sortingByApproverState[this.sortByApproverState] = this.sortDescApproverState;
			}
			let currentPage = (this.currentApproverStatePage - 1);
			ApproverState.getList(this, filter, this.sortingByApproverState, currentPage , this.approverStatePageSize).then(result => {
				this.approverStates = result.data;
				this.totalApproverStateRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETApproverState*/
		/*APP_DETAIL_GETAPPROVERTYPE*/
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVERTYPE*/
		/*APP_DETAIL_GETAPPROVALSTRUCTURE*/
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVALSTRUCTURE*/
		/*APP_DETAIL_GETUSERINFO*/
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETUSERINFO*/
		/*APP_DETAIL_GETACTIVITYSTATE*/
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETACTIVITYSTATE*/
		/*APP_DETAIL_GETAPPROVALCONFIGURATIONINSTANCEDETAIL*/
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVALCONFIGURATIONINSTANCEDETAIL*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'approvalinstancecopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_SAVEBUTTONACTION*/
		saveButtonAction(modalEvent) {
			this.$emit("saveActionMethod", modalEvent);
		},
		/*END_APP_DETAIL_SAVEBUTTONACTION*/
		/*APP_DETAIL_RESETMODAL*/
		resetModal() {
			this.$emit('resetMethod'); 
		},
		/*END_APP_DETAIL_RESETMODAL*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApproverStateFilter = true;
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterApprovalInstance = new ApprovalInstanceFilter();
		this.filterApproverState = new ApproverStateFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	watch : {
		/*APP_DETAIL_OPENPOPUP*/
		openPopup(newValue, oldValue) {
			if (newValue) {
				this.getApprovalInstance(this.modelId);
				this.getApproverStates();
			}
		},
		/*END_APP_DETAIL_OPENPOPUP*/
		/*APP_DETAIL_WATCH_APPROVERSTATE*/
		sortByApproverState : {
			handler: function() {
				this.getApproverStates();
			}
		},
		sortDescApproverState: {
			handler: function() {
				this.getApproverStates();
			}
		},
		currentApproverStatePage: {
			handler: function() {
				this.getApproverStates();
			}
		},
		approverStatePageSize : {
			handler: function() {
				this.getApproverStates();
			}
		},
		filterApproverState: {
			handler: function() {
				this.getApproverStates();
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_APPROVERSTATE*/
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
		isShowPopup: {
			get: function(){
				if (this.openPopup) return true; 
				else return false; 
			},
			set: function(newValue){ }
		},
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
